<app-loader *ngIf="isDisabled"></app-loader>
<!-- <div class="row g-2 py-1">
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/free-vector/recruit-agent-analyzing-candidates_74855-4565.jpg?t=st=1744810656~exp=1744814256~hmac=e155f5c0f18488ed06dfccd6aa3695822b07d6ad9e7c71d397e58f4989420f3e&w=1800"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center cursor-pointer" style="background: #0078D4;color: white;"
                (click)="ModuleTrfr(4)">
                <span class="card-title">Onboarding</span>
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/free-vector/online-job-interview_23-2148613123.jpg?t=st=1744880008~exp=1744883608~hmac=c08161afdb2316a87e4aa67e4fed247822b95b8a8181471f810e8a44d4551071&w=1380"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center cursor-pointer" style="background: #0078D4;color: white;"
                (click)="ModuleTrfr(2)">
                <span class="card-title">Administration</span>
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/free-vector/hotel-staff-concept-illustration_114360-17168.jpg?t=st=1744879910~exp=1744883510~hmac=1d654e6077db5974172fc59d1c3352a01aa7d304059b85f433f5688cda06abc6&w=1380"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center cursor-pointer" style="background: #0078D4;color: white;"
                (click)="ModuleTrfr(3)">
                <span class="card-title">ESS</span>
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/free-vector/home-delivery-worker-uniform_23-2148526780.jpg?t=st=1744879444~exp=1744883044~hmac=d66ae95deb6eaeb72b87c7685a295173ec91e19d59757e9ad98a67ebf4f66ea6&w=1380"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center" style="background: #0078D4;color: white;">
                <span class="card-title">Stock</span>
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/premium-vector/salary-payroll-system-online-income-calculate-automatic-payment-office-accounting-administrative-calendar-pay-date-employee-wages-concept-businessman-standing-with-online-payroll-computer_538610-2069.jpg?w=1380"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center" style="background: #0078D4;color: white;">
                <span class="card-title">Payroll</span>
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/premium-vector/payroll-system-concept-vector-illustration-online-income-calculation-automatic-payment_675567-7307.jpg?w=1380"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center" style="background: #0078D4;color: white;">
                <span class="card-title">Staff Payroll</span>
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/premium-vector/getting-orders-concept-illustration-business-woman-packing-order_598748-350.jpg?w=1380"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center" style="background: #0078D4;color: white;">
                <span class="card-title">OMR</span>
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/premium-vector/confirmed-attendance-concept-illustration_86047-877.jpg?w=1380"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center" style="background: #0078D4;color: white;">
                <span class="card-title">Web Attendance</span>
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="card" style="height:11rem">
            <img class="card-img-top"
                src="https://img.freepik.com/premium-vector/database-statistics-concept-with-character_269730-338.jpg?w=900"
                alt="Card image cap" style="height: 8rem;">
            <div class="card-footer text-muted m-1 text-center" style="background: #0078D4;color: white;">
                <span class="card-title">Edge</span>
            </div>
        </div>
    </div>
</div> -->




<div class="card shadow mt-0" style="height: 100%; background-color: #eef6fa; overflow: auto;">
    <div class="container">
        <!-- <button [routerLink]="['/dashboard/front/' ]" class="btn btn-outline-primary btn-sm">Back</button>
        <h2>MaxEdge ERP Modules</h2> -->

        <div class="d-flex align-items-center position-relative mb-3 mt-1">
            <!-- <button [routerLink]="['/dashboard/front/']"
                class="btn btn-outline-primary btn-sm position-absolute start-0">
                Back
            </button> -->

            <span (click)="routeBack()" class="btn btn-outline-secondary btn-sm position-absolute end-0 mt-1"><i
                    class="bi bi-x"></i>Back</span>

            <!-- <button type="button" class="close position-absolute end-0 mt-1"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button> -->

            <h2 class="mx-auto m-0 text-center">
                MaxEdge ERP Modules
            </h2>
        </div>


        <div class="features-grid">
            <!-- <div class="feature-box shadow">
        <img src="https://img.freepik.com/free-vector/recruit-agent-analyzing-candidates_74855-4565.jpg?t=st=1744810656~exp=1744814256~hmac=e155f5c0f18488ed06dfccd6aa3695822b07d6ad9e7c71d397e58f4989420f3e&w=1800"
            alt="" />
        <p (click)="ModuleTrfr(4)">Onboarding</p>
    </div> -->
            <div (click)="ModuleTrfr(2)" class="feature-box shadow">
                <img src="https://img.freepik.com/free-vector/online-job-interview_23-2148613123.jpg?t=st=1744880008~exp=1744883608~hmac=c08161afdb2316a87e4aa67e4fed247822b95b8a8181471f810e8a44d4551071&w=1380"
                    alt="" />
                <p>Administration</p>
            </div>
            <div (click)="ModuleTrfr(3)" class="feature-box shadow">
                <img src="https://img.freepik.com/free-vector/hotel-staff-concept-illustration_114360-17168.jpg?t=st=1744879910~exp=1744883510~hmac=1d654e6077db5974172fc59d1c3352a01aa7d304059b85f433f5688cda06abc6&w=1380"
                    alt="" />
                <p>HRMS</p>
            </div>
            <!-- <div class="feature-box shadow">
        <img src="https://img.freepik.com/free-vector/home-delivery-worker-uniform_23-2148526780.jpg?t=st=1744879444~exp=1744883044~hmac=d66ae95deb6eaeb72b87c7685a295173ec91e19d59757e9ad98a67ebf4f66ea6&w=1380"
            alt="" />
        <p>Stock</p>
    </div>
    <div class="feature-box shadow">
        <img src="https://img.freepik.com/premium-vector/salary-payroll-system-online-income-calculate-automatic-payment-office-accounting-administrative-calendar-pay-date-employee-wages-concept-businessman-standing-with-online-payroll-computer_538610-2069.jpg?w=1380"
            alt="" />
        <p>Payroll</p>
    </div>
    <div class="feature-box shadow">
        <img src="https://img.freepik.com/premium-vector/payroll-system-concept-vector-illustration-online-income-calculation-automatic-payment_675567-7307.jpg?w=1380"
            alt="" />
        <p>Staff Payroll</p>
    </div>
    <div class="feature-box shadow">
        <img src="https://img.freepik.com/premium-vector/getting-orders-concept-illustration-business-woman-packing-order_598748-350.jpg?w=1380"
            alt="" />
        <p>OMR</p>
    </div>
    <div class="feature-box shadow">
        <img src="https://img.freepik.com/premium-vector/confirmed-attendance-concept-illustration_86047-877.jpg?w=1380"
            alt="" />
        <p>Web Attendance</p>
    </div>
    <div class="feature-box shadow">
        <img src="https://img.freepik.com/premium-vector/database-statistics-concept-with-character_269730-338.jpg?w=900"
            alt="" />
        <p>Edge</p>
    </div> -->
        </div>

    </div>
</div>